<template>
  <div class="value-display">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ValueDisplay'
}
</script>

<style lang="scss" scoped>
.value-display {
  font-size: 60px;
  width: 90px;
  margin: 0;
  font-weight: $fw-bold;
  display: inline-block;
  vertical-align: middle;
}
</style>
